import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { filter, map } from "rxjs/operators";

@Injectable()
export class AppEventService {
    private appEventSubject = new Subject<AppEventType>();

    on(key: AppEventType): Observable<AppEventType> {
        return this.appEventSubject.asObservable().pipe(filter(x => x === key));
    }

    dispatch(data: AppEventType) {
        this.appEventSubject.next(data);
    }
}

export enum AppEventType {
    ProcessAddressValidation,
    AddressValidationFinished,
    OtherService,
}